import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { dataIngestionBatchStatus: { getDataIngestionBatchStatus, } } = apiUrls;

export const DATA_INGESTION_BATCH_STATUS_SUCCESS = 'DATA_INGESTION_BATCH_STATUS_SUCCESS';
export const DATA_INGESTION_BATCH_STATUS_LOADING = 'DATA_INGESTION_BATCH_STATUS_LOADING';


export const getDataIngestionBatchStatusData = ({ fromdate, todate }) => async (dispatch) => {
        try {
            const { url } = getDataIngestionBatchStatus
            const requestData = {
                ...getDataIngestionBatchStatus,
                url: url
                    .replace('{{fromdate}}', fromdate)
                    .replace('{{todate}}', todate)
            };
            const data = await REQUEST(requestData);
            dispatch({
                type: DATA_INGESTION_BATCH_STATUS_SUCCESS,
                data,
            })
        } catch (e) {

            dispatch({
                type: DATA_INGESTION_BATCH_STATUS_SUCCESS,
                data: {
                    code: "",
                    modal: null,
                    notifications: null,
                    paginationInfo: null
                }
            })
        }

    }



export const handleLoader = isLoading => (dispatch) => {
    dispatch({
        type: DATA_INGESTION_BATCH_STATUS_LOADING,
        isLoading
    })
}
